import {
    get_headers
} from '@/utils/constants/constants.js';
import {
    MANAGE_FORM_WORKFLOW,
    GET_ASSIGNED_FORM_STATUS_DATA,
    UNASSIGN_FORM_STATUS,
    ASSIGN_FORM_STATUS,
    CREATE_FORM_APPROVAL_RULES
} from '@/utils/constants/constants.js';
import axios from 'axios';
import $ from 'jquery';

export const workflow_status_mixin = {
    data: () => ({
        workflow_statuses: [],
        form_workflow_id: null,
        headers: get_headers()
    }),

    methods: {
        async manage_form_workflow() {
            const payload = { form_id: Reflect.get(this, 'form_id') };

            try {
                let response = await axios.post(MANAGE_FORM_WORKFLOW, payload, {
                    headers: Reflect.get(this, 'headers')
                });
                const form_statuses = Reflect.get(Reflect.get(Reflect.get(response, 'data'), 'data'), 'form_status_data');

                Reflect.set(this, 'workflow_statuses', form_statuses.map((status, status_index) => {
                    const min_approvals = Reflect.get(status, 'min_approvals');
                    const reviewer_count = min_approvals || 0;
                    const status_reviewer_count = Reflect.get(status, 'status_reviewers_count') || 0;

                    const approval_rules = Reflect.get(status, 'approval_rules');
                    const reviewers = approval_rules.map((reviewer, reviewer_index) => ({
                        id: Reflect.get(reviewer, 'id'),
                        workflow_reviewer_id: Reflect.get(reviewer, 'workflow_reviewer_id') || null,
                        transition_rules_no: Reflect.get(reviewer, 'reviewer_no'),
                        assigned_users: Reflect.get(reviewer, 'assigned_users') || [],
                        selected_role: Reflect.get(reviewer, 'role_id') || null,
                        transition_type: Reflect.get(reviewer, 'transition_type') || 'automatic',
                        conditions: Reflect.get(reviewer, 'conditions') || [],
                        show_conditions: false,
                        action_section_access: Reflect.get(reviewer, 'action_section_access') || {},
                        status_index: status_index,
                        reviewer_index: reviewer_index,
                        to_status_id: Reflect.get(reviewer, 'to_status_id') || '',
                        min_approvals: Reflect.get(reviewer, 'min_approvals') || 1,
                        match_requirement: Reflect.get(reviewer, 'match_requirement') || 'all'
                    }));

                    const status_reviewers = Reflect.get(status, 'status_reviewers') || [];

                    return {
                        id: Reflect.get(status, 'id'),
                        status: this.format_question_type(Reflect.get(status, 'status_name')),
                        order_number: Reflect.get(status, 'order'),
                        assigned: Reflect.get(status, 'is_assigned') ?? false,
                        expanded: reviewers.length > 0 || status_reviewers.length > 0,
                        reviewer_count: reviewer_count,
                        reviewers: reviewers,
                        status_reviewer_count: status_reviewer_count,
                        status_reviewers: status_reviewers.map(reviewer => ({
                            assigned_users: Reflect.get(reviewer, 'assigned_users') || [],
                            selected_role: Reflect.get(reviewer, 'role_id') || null,
                            available_users: [],
                            selected_users: [],
                            user_search: '',
                            filtered_users: []
                        }))
                    };
                }));

                Reflect.get(this, 'workflow_statuses').forEach((status, index) => {
                    if (Reflect.get(status, 'reviewer_count')) {
                        this.update_reviewers(Reflect.get(status, 'reviewer_count'), index);
                    }
                    if (Reflect.get(status, 'status_reviewer_count')) {
                        this.update_status_reviewers(Reflect.get(status, 'status_reviewer_count'), index);
                    }
                });

                Reflect.set(this, 'form_workflow_id', Reflect.get(Reflect.get(Reflect.get(response, 'data'), 'data'), 'form_workflow_id'));
                await this.load_sections_data();
            } catch (error) {
                this.show_error('Error fetching roles: ' + error.message);
            }
        },

        async get_assign_form_status_data() {
            const payload = { form_id: Reflect.get(this, 'form_id') };

            try {
                let response = await axios.post(GET_ASSIGNED_FORM_STATUS_DATA, payload, {
                    headers: Reflect.get(this, 'headers')
                });

                const response_data = Reflect.get(Reflect.get(response, 'data'), 'data');
                Reflect.set(this, 'statuses', Reflect.get(response_data, 'available_statuses').map((status) => ({
                    ID: Reflect.get(status, 'id'),
                    status_name: Reflect.get(status, 'status').replace(/_/g, ' '),
                    is_assigned: !!Reflect.get(status, 'is_assigned')
                })));
            } catch (error) {
                this.show_error('Error fetching roles: ' + error.message);
            }
        },

        get_available_statuses(current_status_id) {
            const workflow_statuses = Reflect.get(this, 'workflow_statuses');
            if (!workflow_statuses || workflow_statuses.length === 0) {
                return [];
            }
            return workflow_statuses.filter(status => Reflect.get(status, 'id') !== current_status_id);
        },

        handle_assignment_toggle(status) {
            Reflect.set(status, 'show_validation', false);

            if (Reflect.get(status, 'is_assigned')) {
                this._assign_entity_type_workflow_status(status);
            } else {
                this.unassign_entity_type_workflow_status(status);
            }
        },

        async _assign_entity_type_workflow_status(status) {
            if (status.length === 0) {
                this.show_error('Please select at least one status to assign to the workflow.');
                return;
            }

            const payload = {
                form_statuses: [{
                    status_id: Reflect.get(status, 'ID'),
                    form_id: Reflect.get(this, 'form_id'),
                }]
            };

            try {
                let response = await axios.post(ASSIGN_FORM_STATUS, payload, {
                    headers: Reflect.get(this, 'headers')
                });

                const response_status = Reflect.get(Reflect.get(response, 'data'), 'status');
                const response_message = Reflect.get(Reflect.get(response, 'data'), 'message');
                
                if (response_status === 'success' || response_message === 'success') {
                    this.show_success('Status assigned to Workflow successfully!');
                    this.manage_form_workflow();
                } else {
                    this.show_error('Error while assigning status');
                }
            } catch (error) {
                this.show_error('Error assigning workflow statuses');
            }
        },

        async unassign_entity_type_workflow_status(status) {
            const payload = {
                status_id: Reflect.get(status, 'ID'),
                form_id: parseInt(Reflect.get(this, 'form_id'), 10),
            };

            try {
                let response = await axios.post(UNASSIGN_FORM_STATUS, payload, {
                    headers: Reflect.get(this, 'headers')
                });

                const response_status = Reflect.get(Reflect.get(response, 'data'), 'status');
                const response_message = Reflect.get(Reflect.get(response, 'data'), 'message');
                
                if (response_status === 'success' || response_message === 'success') {
                    this.show_success('Status unassigned from workflow successfully!');
                    this.manage_form_workflow();
                } else {
                    this.show_error('Error while unassigning status');
                }
            } catch (error) {
                this.show_error('Error unassigning workflow statuses');
            }
        },

        update_reviewers(count, status_index) {
            const workflow_statuses = Reflect.get(this, 'workflow_statuses');
            const status = Reflect.get(workflow_statuses, status_index);

            if (count < 0) {
                Reflect.set(status, 'reviewer_count', 0);
                return;
            }

            if (!Reflect.get(status, 'reviewers')) {
                Reflect.set(status, 'reviewers', []);
            }

            const reviewers = Reflect.get(status, 'reviewers');
            
            if (count > reviewers.length) {
                const reviewers_to_add = count - reviewers.length;
                for (let i = 0; i < reviewers_to_add; i++) {
                    reviewers.push(this.initialize_reviewer());
                }
            } else if (count < reviewers.length) {
                reviewers.splice(count);
            }
        },

        prepare_payload() {
            const workflow_statuses = Reflect.get(this, 'workflow_statuses');
            const payload = {
                form_workflow_id: Reflect.get(this, 'form_workflow_id'),
                rules: workflow_statuses.map((status) => {
                    return {
                        order_number: Reflect.get(status, 'order_number'),
                        status: Reflect.get(status, 'status'),
                        status_id: parseInt(Reflect.get(status, 'id'), 10),
                        reviewer_count: Reflect.get(status, 'reviewer_count'),
                        status_reviewer_count: Reflect.get(status, 'status_reviewer_count'),
                        reviewers: Reflect.get(status, 'reviewers').map((reviewer, reviewer_index) => {
                            const to_status_id = parseInt(Reflect.get(reviewer, 'to_status_id'), 10);

                            return {
                                reviewer_number: reviewer_index + 1,
                                role_id: Reflect.get(reviewer, 'selected_role'),
                                reviewer_type: 'role',
                                specific_user: null,
                                group_users: [],
                                action_section_access: Reflect.get(reviewer, 'action_section_access') || {},
                                assigned_users: Reflect.get(reviewer, 'assigned_users') || [],
                                transition_type: Reflect.get(reviewer, 'transition_type'),
                                conditions: Reflect.get(reviewer, 'conditions') || [],
                                match_requirement: Reflect.get(reviewer, 'selected_match_requirement'),
                                workflow_reviewer_id: Reflect.get(reviewer, 'workflow_reviewer_id') || null,
                                to_status_id: to_status_id,
                                min_approvals: Reflect.get(reviewer, 'min_approvals') || 1
                            };
                        }),
                        status_reviewers: Reflect.get(status, 'status_reviewers').map((reviewer, reviewer_index) => ({
                            reviewer_number: reviewer_index + 1,
                            role_id: Reflect.get(reviewer, 'selected_role'),
                            assigned_users: Reflect.get(reviewer, 'assigned_users') || []
                        }))
                    };
                })
            };

            Reflect.set(payload, 'form_id', parseInt(Reflect.get(this, 'form_id'), 10));
            return payload;
        },

        async submit_approval_workflow() {
            const payload = this.prepare_payload();

            try {
                const response = await axios.post(
                    CREATE_FORM_APPROVAL_RULES,
                    { workflow_id: Reflect.get(this, 'workflow_id'), rules: payload },
                    { headers: Reflect.get(this, 'headers') }
                );

                if (Reflect.get(Reflect.get(response, 'data'), 'status') === "success") {
                    this.show_success('Approval rules successfully saved.');
                    this.manage_form_workflow();
                } else {
                    this.show_error('Something went wrong');
                }
            } catch (error) {
                this.show_error('Failed to submit approval workflow: ' + error.message);
            }
        },

        initialize_data_table() {
            this.$nextTick(() => {
                const table_id = '#assign_form_status_table'

                if (document.querySelector(table_id)) {
                    if ($.fn.DataTable.isDataTable(table_id)) {
                        $(table_id).DataTable().destroy();
                    }
                    $(table_id).DataTable();
                }
            });
        },

        go_back_to_view_entity_type() {
            this.$router.push("/view_entity_type");
        },

        async toggle_status(index) {
            const workflow_statuses = Reflect.get(this, 'workflow_statuses');
            const status = Reflect.get(workflow_statuses, index);

            if (status) {
                Reflect.set(status, 'expanded', !Reflect.get(status, 'expanded'));

                if (Reflect.get(status, 'expanded')) {
                    this.load_status_reviewers(status);
                    await this.get_transition_rules(status);
                }
            }
        }
    }
};